// extracted by mini-css-extract-plugin
export default {"nav":"PomodoroNav_nav__VPyhs","active":"PomodoroNav_active__M1nL2"};